//auth
export const NODE_REGISTER = "/create-user";
export const NODE_LOGIN = "/auth/login";
export const NODE_LOGOUT = "/auth/logout";
export const GOOGLE_LOGIN = "/auth/google"
export const GOOGLE_VERIFY = "/auth/verify-session"
export const VERIFY_CAPTCHA = "auth/verify-captcha"
export const GMAIL_VERFIY = "/gmail-verify"
export const SEND_EMAIL_OTP = "/auth/send-otp"
export const VERIFY_EMAIL_OTP = "/auth/verify-otp"

//stockChats
export const GET_STOCK_CHAT_TITLES = "/get-chat-titles";
export const ADD_NEW_CHAT = "/add-new-chat";
export const DELETE_STOCK_CHAT = "/delete-chat"
export const GET_STOCK_CHAT_MESSAGES = "/get-chat-messages"
export const SEND_USER_MESSAGE = "/send-message"

//contacts
export const GET_CONTACTS = '/contacts/getContacts';
export const GET_LOGS =  '/logs/getAllLogs';
export const GET_DEV_LOGS_FROM_FILE =  '/logs/getDevLogs';
export const GET_DEV_LOGS_FROM_DB =  '/logs/getDevLogsFromDatabase';
export const GET_ACTION_LOGS = './logs/getActionLogs';
export const GET_EMAIL_LOGS_FROM_DB = './logs/emailLogs';
export const GET_SCHEDULER_LOGS = './logs/getScheduleLogs';
export const GET_ADMIN_QUERY_RESPONSE = './logs/getAdminQueryResponse';
export const GET_ADMIN_QUERY_RESPONSE_FROM_USER_DB = './logs/getAdminQueryResponseFromUserDb';
export const GET_MESSAGE_RESPONSE_FOR_ADMIN ='./process-thread'



export const UPDATE_CONTACT_TYPE = '/contacts/updateContactType';
export const UPDATE_CONTACT_TRACK_ABILITY = '/update-trackability';
export const SET_FOLLOWUP_CONFIG = '/contacts/setFollowUpConfig';
export const GET_FOLLOWUP_CONFIG = '/contacts/getFollowUpConfig';

export const GET_FOLLOWUP_SCHEDULE = '/contacts/getFollowupSchedule';

//actions
export const EDIT_ACTIONS = '/updateAction'
export const CLOSE_ACTION = '/closeAction'

export const GET_TRACKABLE_EMAIL_ACTIONS = '/getThreadEmailsActions';
export const  GET_ACTION_BY_USER_ID_AND_ACTION_ID  = '/get-action';


export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const JWT_REGISTER = "/post-jwt-register";
export const POST_FAKE_REGISTER = "/post-fake-register";

export const USER_CHANGE_PASSWORD = "/user-change-password";


export const RECEIVE_BOT_MESSAGE = "/receive-bot-messsage"
export const CHANGE_SELECTED_CHAT = "/change-selected-chat"

